const BASE_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:3001/api";

class ApiService {
  constructor() {
    this.baseURL = BASE_URL;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    const token = localStorage.getItem("authToken");

    const config = {
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
        ...options.headers,
      },
      ...options,
    };

    if (config.body && typeof config.body !== "string") {
      config.body = JSON.stringify(config.body);
    }

    try {
      const response = await fetch(url, config);

      // Handle unauthorized (expired / invalid token)
      if (response.status === 401) {
        // Clear stored auth data
        try {
          localStorage.removeItem("authToken");
          localStorage.removeItem("authUser");
          sessionStorage.removeItem("adminAuthenticated");
          sessionStorage.removeItem("adminToken");
        } catch (_) {}

        // Avoid redirect loop: only redirect if not already on login
        if (
          typeof window !== "undefined" &&
          window.location.pathname !== "/admin"
        ) {
          // Use replace so back button doesn't return to protected page
          window.location.replace("/admin");
        }
        throw new Error("Unauthorized (401)");
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        return await response.json();
      }

      return response;
    } catch (error) {
      console.error("API request failed:", error);
      throw error;
    }
  }

  get(endpoint) {
    return this.request(endpoint, { method: "GET" });
  }

  post(endpoint, data) {
    return this.request(endpoint, {
      method: "POST",
      body: data,
    });
  }

  put(endpoint, data) {
    return this.request(endpoint, {
      method: "PUT",
      body: data,
    });
  }

  patch(endpoint, data) {
    return this.request(endpoint, {
      method: "PATCH",
      body: data,
    });
  }

  delete(endpoint) {
    return this.request(endpoint, { method: "DELETE" });
  }
}

export const apiService = new ApiService();
